import { useState } from "react";
import OfficerProfile from "./OfficerProfile"
import TeamProfile from "./TeamProfile"
import "../style.css"

const WelcomeMeetPage = () => {
    const [selectedTeam, setSelectedTeam] = useState<string | null>(null);

    const styles = {


        container: {
            height: "auto",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            color: "white",
        },

        content: {
            position: "relative" as "relative",
            height: "auto",
            maxHeight: "95%",
            width: "95%",
            maxWidth: "1280px",
            fontSize: "clamp(16px, 4vw, 22px)",
            fontFamily: "'Raleway', Arial",
            padding: "clamp(80px, 10vh, 130px) 0px",
            margin: "auto",
            verticalAlign: "middle",
            textAlign: "center" as "center",
        },
        contentAlt: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            position: "relative" as "relative",
            display: "block",
            height: "100%",
            width: "100%",
            color: "#FFF",
            fontSize: "20px",
            fontWeight: "300",
            fontFamily: "'Raleway', Arial, sans-serif",
            padding: "100px 0px",
            margin: "auto",
            verticalAlign: "middle",
            textAlign: "center" as "center",
        },
        sectionTitle: {
            fontSize: "32px",
            paddingBottom: "20px",
            margin: "0px",
            fontWeight: "normal",
        },
        sectionTitleAlt: {
            color: "#FFF",
            fontSize: "32px",
            paddingBottom: "20px",
            margin: "0px",
            fontWeight: "normal",
        },
        newsArticles: {
            width: "95%",
            maxWidth: "1280px",
            textAlign: "left" as "left",
            margin: "30px auto",
            fontWeight: "300",
        },
        button: {
            margin: "10px",
            padding: "10px 20px",
            fontSize: "18px",
            backgroundColor: "#141619",
            color: "white",
            border: "1px solid #ddd",
            borderRadius: "8px",
            cursor: "pointer",
        },
        activeButton: {
            backgroundColor: "#050A44",
        },
    }

    const renderTeamProfile = () => {
        switch (selectedTeam) {
            case "Mechanical Team":
                return (
                    <TeamProfile
                        teamName="Mechanical Team"
                        teamDescription={
                            <p>The mechanical team is responsible for designing and building all structural components of the submarine.
                                We use SolidWorks to create detailed 3D models and part drawings for the various components of the sub.
                                This software allows us to visualize the entire system, test designs virtually, and make necessary adjustments before manufacturing the final parts.
                                Once the designs are finalized, we manufacture the parts using a variety of materials, including aluminum, acrylic, PVC, and PLA.
                                We use 3D printers and the College of Engineering’s machine shop to produce our parts with a high degree of precision.<br /><br />
                                Our team is involved in ensuring the submarine meets all necessary buoyancy and mechanical specifications. We use spreadsheets to perform buoyancy calculations, which help us determine the ideal material choices and designs for different components.
                                To comply with competition specifications, we must ensure that our robot and all components that detach from it during competition are buoyant by at least 0.5% by weight.
                                One of the most crucial aspects of our work is collaborating with the electrical team to determine size requirements for our electronics enclosures, ensuring that all components fit securely and wires can be routed between boards and our bulkhead connectors.
                                We design our electronics enclosures with tight tolerances to ensure that they will be waterproof.
                                Additionally, the mechanical team produces the items necessary for testing the capabilities of our robot, including building structures out of PVC pipe to imitate the competition tasks. <br /> <br />
                                Currently, the mechanical team is focused on enhancing the robot's capabilities by designing new torpedo and grabber mechanisms.
                                These systems are designed to allow our sub to complete more tasks during the competition, allowing us to earn more points.
                                We use SolidWorks Flow Simulation to perform CFD simulations on our torpedoes to obtain crucial information like the drag coefficient. This allows us to determine what size of spring we need to propel our torpedoes through the water to their target.
                                Creating these systems is a long process that requires us to ensure they function properly, while also managing their weights to ensure that the sub remains balanced without the excessive addition of fishing weights or pool noodles.
                            </p>
                        }
                        teamImagePath="/images/teamPhotos/MechanicalTeamPhoto_smaller.jpg"

                        officer1={<OfficerProfile officerImagePath="/images/officers/Lauren.jpg"
                            name="Lauren Bouckaert" title="Mechanical Team Lead" />}
                        officer2={<OfficerProfile officerImagePath="/images/officers/Izzie.jpg"
                            name="Izzie Mulita" title="Mechanical Team Lead" />}
                    />
                );
            case "Software Team":
                return (
                    <TeamProfile
                        teamName="Software Team"
                        teamDescription={
                            <p>
                                The software team's main responsibility is making the sub able to navigate an underwater obstacle course autonomously.
                                We seek to accomplish this task by using a combination of sensor data and machine learning.
                                We use machine learning to help us find objects and choose what the agenda is dynamically based on the bot's proximity to tasks.
                                The software team also works closely with both the mechanical and electrical team members to design and integrate new parts and systems into the sub.
                                These additions then allow the bot to tackle new tasks such as manipulating shells with a grasper of some kind. <br /> <br />
                                As a new bot is built we are taking the opportunity to upgrade and update our systems. This update is starting with the switch from legacy ROS to its successor ROS 2.
                                While building a new sub we had to come up with ways to test the new software so we spent time working to model the bot to enable rapid developments while limiting the need for costly pool tests. <br /> <br />
                                As a team we have worked together to achieve both individual and team goals, and are incredibly pleased at the positive impacts made on both our members and the school community.
                            </p>
                        }
                        teamImagePath="/images/teamPhotos/SoftwareTeamPhoto_smaller.jpg"
                        officer1={<OfficerProfile officerImagePath="/images/officers/Andrew.jpg"
                            name="Andrew Culbertson" title="Software Team Lead" />}
                    />
                );
            case "Electrical Team":
                return (
                    <TeamProfile
                        teamName="Electrical Team"
                        teamDescription={
                            <p>
                                This year the surf electrical team is working on a complete redesign of the sub's electronics. We are creating several new PCB boards.
                                The different boards all serve different functions. First, we are designing the circuits in an Electronic Design Automation software(EDA).
                                We simulate the circuit in a spice simulator. Second, we go through the circuit and start selecting part and Integrated circuits(ICs). This can be
                                the most time intensive part of the process. We pour over datasheet, comparing requirements, and changing our designs to make it more practical
                                and efficient. Finally, we built a 3D model of the circuit board. This part requires a lot of planning and revision. A lot of factors go into
                                a good design. All of these tasks are not taught in the Electrical engineering program and require us to research and learn on our own.
                                <br /> <br />
                                All of this requires planning. We have created a block diagram this year. A block diagram helps organize all the interconnected parts
                                of the electronics. We have been working with professors to improve our systems and solve problems. This block diagram helped us decide to create
                                four circuit boards. We have a power board that connects and regulates the battery. A process control board that holds the computer. The sensor board
                                that contains important and delicate sensors. And Finally, the Motor board, this connects the computer to the motors and controls them.

                                To complete all this, we divide ourselves into smaller groups led by the seniors. We try to teach the newer members what we have learned. We dedicate
                                a lot of time to documentation. It's important that when the senior members leave, we have a well-trained group able to pick up were others left off.
                                New members are tasked with assisting seniors with their work, doing research projects on circuit design for the sub, and making side project that
                                teach them important skills. The goal of the electrical team is that everyone learns as much as possible while building the sub as a team.
                            </p>
                        }
                        teamImagePath="/images/teamPhotos/ElectricalTeamPhoto_smaller.jpg"
                        officer1={<OfficerProfile officerImagePath="/images/officers/Aden.jpg"
                            name="Aden Gianfrancisco" title="Electrical Team Lead" />}
                        officer2={<OfficerProfile officerImagePath="/images/officers/Carson_Heurtin.jpg"
                            name="Carson Heurtin" title="Electrical Team Lead" />}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <div className="backdrop">

            <div id="aboutUs" className="container" style={{
                ...styles.container,
                borderBottom: "solid 24px #131c81",

            }}>
                <div className="content" style={styles.content}>
                    <br />
                    <br />

                    {/*
                    <img src={"/images/logos/surfLogo.png"}
                        alt="surf_logo"
                        style={{
                            width: "200px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            alignContent: "center",
                        }} />
                    */}
                    <p>Students’ Underwater Robotics Foundation is an engineering student organization
                        that strives to implement the knowledge of engineering courses to real life projects.
                        Mizzou SURF designs and manufactures marine robotic projects. SURF is a competition
                        team with an element of robotic research. We are currently hard at work preparing
                        for the 2026 RoboSub competition at the Woollett Aquatics Center in Irvine, California!</p>
                    <img src={"/images/backgroundImages/newSURFGroupPhoto_smaller.jpg"}
                        alt="team"
                        style={{
                            maxWidth: "100%",
                            width: "clamp(300px, 90vw, 785px)",
                            objectFit: "cover",
                            borderRadius: "8px",
                            alignContent: "center",
                            margin: "50px 10px",
                        }} />
                    <div
                        style={{
                            display: "block",
                            width: "100%",
                            //boxSizing: "border-box",
                            color: "white",
                            backgroundColor: "#141619",
                            maxWidth: 1280,
                            margin: "0px auto 0px",
                            padding: "0 12px",
                        }}
                    >
                        <br />
                        <h3 id="officers" className="sectionTitle" style={styles.sectionTitle}>Meet the Officers: </h3>
                        {/*Div for the officerprofiles for exec. Now wrapping based on screen size.*/}
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "center",
                                //gap: "16px",
                                alignItems: "flex-start",
                                width: "100%",
                                //boxSizing: "border-box",
                            }}
                        >
                            <OfficerProfile officerImagePath="/images/officers/Kaden.jpg"
                                name="Kaden Culbertson" title="Co-President" />
                            <OfficerProfile officerImagePath="/images/officers/Henry.jpg"
                                name="Henry Bloch" title="Co-President" />
                            <OfficerProfile officerImagePath="/images/officers/Andrew.jpg"
                                name="Andrew Culbertson" title="Treasurer" />
                            <OfficerProfile officerImagePath="/images/officers/Izzie.jpg"
                                name="Izzie Mulita" title="Secretary" />
                            <OfficerProfile officerImagePath="/images/officers/Jadyn.jpg"
                                name="Jadyn Smith" title="Webmaster" />
                        </div>


                        <br />
                        <h3 className="sectionTitle" style={styles.sectionTitle}>Meet the Teams: </h3>
                        <div>
                            {/* Buttons to select the team */}
                            <button
                                style={{
                                    ...styles.button,
                                    ...(selectedTeam === "Mechanical Team" ? styles.activeButton : {}),
                                }}
                                onClick={() => setSelectedTeam("Mechanical Team")}
                            >
                                Mechanical Team
                            </button>
                            <button
                                style={{
                                    ...styles.button,
                                    ...(selectedTeam === "Software Team" ? styles.activeButton : {}),
                                }}
                                onClick={() => setSelectedTeam("Software Team")}
                            >
                                Software Team
                            </button>
                            <button
                                style={{
                                    ...styles.button,
                                    ...(selectedTeam === "Electrical Team" ? styles.activeButton : {}),
                                }}
                                onClick={() => setSelectedTeam("Electrical Team")}
                            >
                                Electrical Team
                            </button>
                        </div>
                        {/* Render the selected team profile */}
                        {renderTeamProfile()}
                        <br />
                    </div>
                </div>
            </div>
        </div>

    )
}

export default WelcomeMeetPage
